<template>
  <div class="collab-roles-detail">
    <div class="file-header nav-bar-bgcolor">
      <div class="back-nav back-arrow" @click="handleClose">
        <i class="iconfont icon-back"></i>
      </div>
      <div class="collab-nav-title">{{$t('collab.role.details')}}</div>
    </div>
    <div class="detail-container">
      <!-- group department header -->
      <div v-if="collabItem.is_group" class="collab-item-dept">
        <avatar
          class="thumb-icon collab-item-avatar"
          :user="{
            id: groupInfo.id,
            name: groupInfo.name
          }"
          :type="collabItem.user.is_department && 'department' || 'group'"
          :size="52"
        />
        <div class="account-group-details">
          <div class="group-title">
            <span class="ellipsis name">{{groupInfo.name}}</span>
            <span v-if="!collabItem.accepted" class="accept-status">{{$t('collab.notAcceptedYet')}}</span>
          </div>
          <div class="group-description">
            <span>{{groupInfo.user_count + $t('unit.person')}}</span>
            <span v-if="groupInfo.current_user">({{$t('collab.includingMe')}})</span>
            <span v-if="collabItem.user.is_department" class="dept-name ellipsis">
              {{'，' + $t('collab.belong') +  (groupInfo.parent_department.path || '')}}
            </span>
          </div>
        </div>
      </div>
      <!-- user header-->
      <div v-if="!collabItem.is_group" class="collab-item-user">
        <avatar
          class="thumb-icon collab-item-avatar"
          :user="{
            profile_pic_key: collabItem.user && collabItem.user.profile_pic_key,
            id: collabItem.user && collabItem.user.id,
            full_name_pinyin: collabItem.user && collabItem.user.full_name_pinyin,
            name_first_letter: collabItem.user && collabItem.user.name_first_letter,
            name: collabItem.user && collabItem.user.name
          }"
          :isActive="collabItem.isActive"
          :type="collabItem.is_group && 'department'"
          :size="80"
        />
        <div class="account-details-user ellipsis">
          <span>{{userInfo.user.name}}</span>
          <span class="account-status-activte">
          <span v-if="!collabItem.accepted" class="account-status">{{$t('collab.notAcceptedYet')}}</span></span>
          <span v-if="collabItem.current_user" class="account-status-mine">({{$t('base.me')}})</span>
        </div>
      </div>
      <div class="detail-cell-wrap" v-if="!collabItem.is_group">
        <div class="detail-cell" v-if="userInfo.user.phone">
          <div class="title">{{$t("base.mobile")}}</div>
          <div class="description">
            <a v-if="userInfo.user.is_phone_public" :href="`tel:${userInfo.user.phone}`">{{userInfo.user.phone}}</a>
            <span v-else>{{userInfo.user.phone}}</span>
          </div>
        </div>
        <div class="detail-cell" v-if="userInfo.user.email">
          <div class="title">{{$t("base.email")}}</div>
          <div class="description">
            <a :href="`mailto:${userInfo.user.email}`">{{userInfo.user.email}}</a>
          </div>
        </div>
        <div class="detail-cell border-none">
          <div class="title">{{$t("base.department")}}</div>
          <div class="description-group">
            <div v-for="(item, index) in userInfo.user.departments" :key="index">{{item.name}}</div>
          </div>
        </div>
      </div>
      <van-cell
        :class="{'collab-cell-level': true, mb30: !canRemoveRole}"
        :title="$t('collab.roles')"
        :value="$t(store.collabState.roleMessage[store.collabState.currentRoleLevel])"
        @click="handleCollabLevelClick"
        :is-link="calcPermission"
      />
      <div class="collab-actions" v-if="canRemoveRole" @click="handleRemove">{{rolesAction}}</div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {i18n} from '@/utils/i18n'
import {Cell} from 'vant'
import Avatar from '../utils/Avatar'
import CollabLevel from '../collab/CollabLevel'
import ajax from '@/utils/ajax'
import {getQueryString, toast, loading, confirm} from '@/utils/common'
import {CARDS_USER_INFO, CARDS_DEPARTMENT_INFO, COLLAB_DELETE, CARDS_GROUP_INFO} from '@/config/api'

Vue.use(Cell)

export default {
  name: 'collab',
  i18n,
  data () {
    return {
      activeItem: false,
      userInfo: {
        user: {}
      },
      groupInfo: {
        parent_department: {}
      }
    }
  },
  components: {
    Cell,
    Avatar,
    CollabLevel
  },
  props: {
    headerItem: Object,
    collabItem: Object
  },
  computed: {
    rolesAction () {
      const {user: {is_group, is_department} = {}} = this.collabItem

      if (this.canQuitCollab) return i18n.t('collab.invite.quit')
      if (is_group && is_department) {
        return i18n.t('collab.remove.department')
      } else if (is_group) {
        return i18n.t('collab.remove.group')
      } else {
        return i18n.t('collab.remove.roles')
      }
    },
    rolesDialogTip () {
      const {user: {is_group, is_department} = {}} = this.collabItem

      if (is_group && is_department) {
        return i18n.t('collab.remove.department.confirm')
      } else if (is_group) {
        return i18n.t('collab.remove.group.confirm')
      } else {
        return i18n.t('collab.remove.roles.confirm')
      }
    },
    canRemoveRole () {
      if (this.canQuitCollab) return true
      const {direct_role, current_user, is_group} = this.collabItem
      const {final_role} = this.headerItem

      // 只要是继承的都不能删除
      // 自己的文件夹不能删除
      // 只有owner coowner 才能删除
      // 群组或者部门的文件夹可以删（只有owner coowner可以删除）
      // coowner 不能删除 owner
      // coowner 不能删除 coowner
      if ((final_role === 'coowner') && ['owner', 'coowner'].includes(this.collabItem.final_role)) return false

      return (direct_role && ['owner', 'coowner'].includes(final_role)) && (is_group || (!is_group && !current_user))
    },
    canQuitCollab () {
      const {quit_collab_allowed} = this.collabItem

      return quit_collab_allowed
    },
    calcPermission () {
      const {direct_role, final_role} = this.collabItem
      const isOwner = this.headerItem.final_role === 'owner'
      const isCoowner = this.headerItem.final_role === 'coowner'

      // TODO 共同所有者账号测试
      if (
        // owner 无法修改自己的权限
        (isOwner && final_role === 'owner' && direct_role) ||
        // owner 无法修改别人 继承下的 共同所有者的权限
        (isOwner && !direct_role && ['owner', 'coowner'].includes(final_role)) ||
        // 不是 'owner', 'coowner' 什么都不能改
        (!isOwner && !isCoowner) ||
        // 共同所有者 改不了 自己和所有者
        (isCoowner && ['owner', 'coowner'].includes(final_role))
      ) return false

      return true
    }
  },
  watch: {
    $route (to, from) {
      const { collabRolesDetail } = to.query
      const { collabLevel } = from.query

      if (collabRolesDetail) {
        // 如果是来自collabLevel 或者 去collabLevel 则跳出
        if (collabLevel || to.query.collabLevel) return
        const {user: {is_group, is_department} = {}} = this.collabItem
        const loadingStatus = loading()

        if (is_group && is_department) {
          this.getDepartmentInfo(loadingStatus)
        } else if (is_group) {
          this.getGroupInfo(loadingStatus)
        } else {
          this.getUserInfo(loadingStatus)
        }
      } else {
        // 隐藏时，初始化数据
        this.userInfo = {user: {}}
        this.groupInfo = {parent_department: {}}
      }
    }
  },
  methods: {
    getUserInfo (loadingStatus) {
      const {user: { id } = {}} = this.collabItem
      const {typed_id} = this.headerItem

      ajax({
        url: `${CARDS_USER_INFO}?${getQueryString({user_id: id, item_typed_id: typed_id})}&_t=${new Date().getTime()}`
      }).then(result => {
        loadingStatus.clear()
        this.userInfo = result
      })
    },
    getDepartmentInfo (loadingStatus) {
      const {user: { department_id } = {}} = this.collabItem
      const {typed_id} = this.headerItem

      ajax({
        url: `${CARDS_DEPARTMENT_INFO}?${getQueryString({department_id, item_typed_id: typed_id})}&_t=${new Date().getTime()}`
      }).then(result => {
        loadingStatus.clear()
        this.groupInfo = result.department
      })
    },
    getGroupInfo (loadingStatus) {
      const {user: { id } = {}} = this.collabItem
      const {typed_id} = this.headerItem

      ajax({
        url: `${CARDS_GROUP_INFO}?${getQueryString({group_id: id, item_typed_id: typed_id})}&_t=${new Date().getTime()}`
      }).then(result => {
        loadingStatus.clear()
        this.groupInfo = result.group
      })
    },
    handleCollabLevelClick () {
      this.calcPermission && this.toggleQuery('collabLevel')
    },
    handleActive (activeItem) {
      this.activeItem = activeItem
    },
    handleClose () {
      this.toggleQuery('collabRolesDetail')
    },
    handleRemove () {
      const message = this.canQuitCollab ? `${i18n.t('base.collab.quit')}?` : this.rolesDialogTip

      confirm({
        message,
        confirmButtonText: (this.canQuitCollab && i18n.t('base.quit')) || i18n.t('collab.invite.delete'),
        className: 'role-detail-dialog'
      }).then((action) => {
        const {collab_id, user: {is_department, is_group} = {}} = this.collabItem
        const type = is_group ? is_department ? 'department' : 'group' : 'roles'

        ajax({
          url: `${COLLAB_DELETE}?_t=${new Date().getTime()}`,
          data: {collab_ids: [collab_id]},
          method: 'POST'
        }).then((result) => {
          if (this.canQuitCollab) {
            toast.success(i18n.t('collab.invite.quitSuccess'))
            setTimeout(() => {
              this.$router.go(-2)
            }, 1500)
          } else {
            this.$emit('remove-role', type)
            this.setState({collabState: {...this.store.collabState, refreshCollabList: new Date().getTime()}})
            this.toggleQuery('collabRolesDetail')
          }
        })
      }).catch(() => {})
    }
  }
}

</script>
<style lang="postcss">
.collab-roles-detail {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  width: 100%;
  flex: 1;
  height: 100%;
  background-color: #eff2f6;
  font-size: 16px;

  & .back-arrow {
    z-index: 1;
  }

  & .collab-nav-title {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    text-align: center;
  }

  & .icon-back {
    font-size: 17px;
  }

  & .van-dialog__confirm,
  & .van-dialog__confirm:active {
    color: #ff5555;
  }

  & .dialog-content {
    line-height: 22px;
    height: 22px;
    margin: 19px 0;
  }

  & .detail-container {
    display: flex;
    flex-direction: column;
    overflow: auto;
    font-size: 16px;
    flex: 1;

    & .collab-item-avatar {
      flex: 0 0 auto;
    }

    & .collab-item-dept {
      display: flex;
      padding: 16px 16px;
      background-color: #fff;
      margin: 36px 0;

      & .account-group-details {
        flex: 0 1 auto;
        overflow: hidden;
        border-bottom: none;
        margin-left: 11px;

        & .group-title {
          display: flex;
          font-size: 18px;
          line-height: 25px;
          flex: 1;

          & .name {
            flex: 1;
          }

          & .accept-status {
            flex: 0 0 auto;
            font-size: 18px;
            color: #ff5555;
          }
        }

        & .group-description {
          display: flex;
          line-height: 20px;
          font-size: 14px;
          color: #848484;
          margin-top: 5px;

          & span {
            flex: 0 0 auto;
          }

          & span.dept-name {
            flex: 0 1 auto;
          }
        }
      }
    }

    & .collab-item-user {
      height: 152px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      margin-bottom: 10px;
      flex: 0 0 auto;

      & .account-details-user {
        font-size: 18px;
        line-height: 25px;
        margin-top: 8px;
        max-width: 100%;

        & .account-status-mine {
          color: #6ca2ff;
        }

        & .account-status-activte {
          color: #ff5555;
        }
      }

    }

    & .van-cell {
      font-size: 16px;

      & .van-cell__value {
        color: #848484;
      }
    }

    & .detail-cell-wrap {
      background: #fff;
      display: flex;
      flex-direction: column;
      font-size: 16px;
      flex: 0 0 auto;
      & .detail-cell {
        margin-left: 15px;
        flex: 0 0 auto;
        border-bottom: 1px solid #e5e7e9;

        & .title {
          margin-top: 8px;
        }

        & .description {
          min-height: 22px;
          color: #3d95f2;
          margin-top: 2px;
          margin-bottom: 8px;
        }

        & .description-group {
          margin-top: 2px;
          margin-bottom: 8px;
          margin-right: 15px;
          color: #848484;
        }
      }

      & .border-none {
        border: none;
      }
    }

    & .collab-roles-choose {
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      color: #848484;
      padding-left: 15px;
      margin-top: 20px;
    }

    & .collab-actions {
      text-align: center;
      color: #ff5555;
      background-color: #fff;
      height: 44px;
      line-height: 44px;
      margin-top: 10px;
      margin-bottom: 30px;
    }

    & .svg-active {
      height: 14px;
      width: 20px;
      position: absolute;
      right: 0;
      top: 5px;
    }

    & .van-cell__value {
      position: relative;
    }

    & .roles-detail {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      background-color: #000;

      & .img {
         transform: rotate(90deg);
      }
    }

    & .collab-cell-level {
      margin-top: 10px;
      flex: 0 0 auto;
    }
  }
}
</style>
